import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import CommentItem from './CommentItem.jsx';
import Form from './Form.jsx';
import qs from 'qs';
import { Link } from 'react-router-dom';
import { custom } from "../../utils/linker";

import { observer, inject } from 'mobx-react';
import { observable, makeObservable, action } from 'mobx';
import ReplyForm from "./ReplyForm";
import Portal from "../Helpers/Portal";
import CommentsRefresher from "./CommentsRefresher";
import CenterScroller from "../Helpers/CenterScroller";
import historyVars from "../../utils/historyVars";

class Comments extends Component {
  vars={
    list:null,
    loaded:false,
    reply_comment:0,
    reply_to:{},
    margin_left:0
  }
  constructor(props){
    super(props);

    makeObservable(this,{
      vars:observable,
      setComments:action
    });

    this.state={
      list:null,
      loaded:false,
      reply_comment:0,
      reply_to:{},
      margin_left:0
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.focus && this.props.focus!==prevProps.focus) {
      this.focusComments();
    }

    console.log("update! <---------");
    if(this.props.commentsStore.scroll_save.enable) {
      console.log("update! scroll go <---------");
      this.props.commentsStore.scroll_save.enable=0;
      const scrollOb = this.props.commentsStore.getScrollOb();
      let lastScrollHeight=0;

      const scrollFreeze=()=> {
        const newScroll = {
          scroll_top: scrollOb.scrollTop,
          scroll_height: scrollOb.scrollHeight
        };

        if(this.props.commentsStore.scroll_save.type === "all") {
          scrollOb.scrollTop = this.props.commentsStore.scroll_save.scroll_top;
        } else {
          if (lastScrollHeight != newScroll.scroll_height) {
            lastScrollHeight = newScroll.scroll_height;
            const heightDiff = newScroll.scroll_height - this.props.commentsStore.scroll_save.scroll_height;
            console.log("heightDiff",  {
              diff:heightDiff,
              new_height: newScroll.scroll_height,
              old_height: this.props.commentsStore.scroll_save.scroll_height,
              cur_scroll_top: scrollOb.scrollTop,
              old_scroll_top: this.props.commentsStore.scroll_save.scroll_top,
            });
            scrollOb.scrollTop += heightDiff;
            // scrollOb.scrollTop += (heightDiff - 502);
          }
        }

      };
      scrollFreeze();

      /*let interval=setInterval(()=> {

      },100);*/



    }
      // this.props.commentsStore.moveToCommentId(this.props.commentsStore.before_load_last_id);

    // console.log("didupdate!");
  }

  focusComments() {
    console.log('FOCUS!');
    const rect=this._wrapRef.getBoundingClientRect();
    console.log('rect',rect);
    document.querySelectorAll('html')[0].scrollTop=rect.top;
    document.querySelectorAll('body')[0].scrollTop=rect.top;
  }

  getLoadingId(props){
    return `${props.category}-${props.element}`;
  }
  setComments(answer) {
    this.vars.list=answer;
    this.vars.loaded=true;
    /*this.setState({
      reply_comment:0,
      reply_to:{},
      margin_left:'',
      list:answer,
      loaded:true
    });*/
  }
  loadList(props,force) {
    if(force || this._loading!==this.getLoadingId(props)) {
      this._loading=this.getLoadingId(props);
      let query='';
      if(this.props.query) {
        query=`?${qs.stringify(this.props.query)}`;
      }
      axios.get(`/api/comments/${props.category}/${props.element}${query}`).then((item)=>{
        this.setComments(item.data.answer);
        if(this.props.focus) {
          this.focusComments();
        }
      });
    }
  }
  getList() {
    if(this.props.commentsStore.list.inited) {
      if(this.props.commentsStore.list.data.items.length>0) {
        return this.props.commentsStore.list.data.items.map((item, index) => {
          return (
            <div key={item._id}>
              <CommentItem {...custom(this.props.commentsStore.list.data.items, index)} />
            </div>
          )
        });
      }
    }
  }
  getReplyForm(commentId) {
    return null;
    if (commentId == this.vars.reply_comment) {
      return (
        <div style={{marginLeft:this.vars.margin_left}}>
          <Form reply_to={this.vars.reply_to} key="reply_form" onSubmit={()=>{ this.loadList(this.props,true);  }} element={this.props.element}
              category={this.props.category}/>
        </div>
      )
    } else {
      if(commentId===0) {
        return (
          <div className="pbottom10">
            <span className="btn4 only-s-w100" onClick={()=>{
              this.vars.reply_to={};
              this.vars.reply_comment=0;
              this.vars.margin_left='';
            }}><span>reply here</span></span>

          </div>
        )
      }
    }
    return null;
  }
  getCommentsUrl() {
    if(this.props.commentsUrl) {
      return this.props.commentsUrl;
    } else {
      return `${this.props.router.location.pathname}/comments`;
    }
  }
  getShowAll() {
    if(this.props.query) {
      return (
        <div>
          <Link to={this.getCommentsUrl()} className="btn4 only-s-w100"><span>Показать все комментарии</span></Link>
        </div>
      )
    }
    return null;
  }
  renderBeforeButton() {
    if (this.props.commentsStore.list.inited) {
      if (this.props.commentsStore.list.data.items.length > 0) {
        if(this.props.commentsStore.list.data.have_before) {
          if(this.props.commentsStore.list.fetching == "before") {
            return (
              <div className="bg-w1 bo-w2 solid1 rad4 padd10 lh15 tac mbottom10 pointer bg-w2-hover">
                Загрузка...
              </div>
            );
          }
          return (
            <div className="up12 margin">
              <div onClick={()=>{ this.props.commentsStore.loadBefore(); }} className="cell s-auto bg-w1 bo-w2 solid1 rad4 padd10 lh15 tac mbottom10 pointer bg-w2-hover">
                Загрузить прошлые комментарии
              </div>
              <div onClick={()=>{ this.props.commentsStore.loadAll(); }} className="cell s-shrink bg-w1 bo-w2 solid1 rad4 padd10 lh15 tac mbottom10 pointer bg-w2-hover">
                Загрузить все
              </div>
            </div>
          )
        }
      }
    }
  }
  renderAfterButton() {
    if (this.props.commentsStore.list.inited) {
      if (this.props.commentsStore.list.data.items.length > 0) {
        if(this.props.commentsStore.list.data.have_after) {
          return (
            <div className="bg-w1 bo-w2 solid1 rad4 padd5 tac mbottom10 pointer">
              Загрузить еще
            </div>
          )
        }
      }
    }
    return null;
  }
  renderCommentNotFound() {
    if(this.props.commentsStore.comment_not_found) {
      return (
        <CenterScroller loaded={1} unmountOverflow='visible' center={true} maxWidth={340} closeTrigger={()=>{
          this.props.commentsStore.comment_not_found=false;
          historyVars.appendVars({ [this.props.commentsStore.comment_url_var]:null });
        }} >
          <div className="padd20 bg-w1 rad10">
            <div className="font1 fs24 const2 pbottom10">Ошибка</div>
            <p>Искомый комментарий не найден.</p>
            <p>Возможно он был удален.</p>
            <div className="tar">
              <span onClick={()=>{ this.props.commentsStore.comment_not_found=false; historyVars.appendVars({ [this.props.commentsStore.comment_url_var]:null }); }} className="btn1"><span>Закрыть</span></span>
            </div>
          </div>
        </CenterScroller>
      )
    }
    return null;
  }
  render() {
    return (
      <div className="center" ref={(ref)=>{ this._wrapRef=ref; }} style={{maxWidth:950}}>
        <h2>Комментарии</h2>
        <ReplyForm id={0} marginLeft={0} />
        {this.getReplyForm(0)}
        {this.renderBeforeButton()}
        {this.getList()}
        {this.renderAfterButton()}
        {this.getShowAll()}
        {this.props.commentsStore.list.inited && this.props.commentsStore.list.data.items.length>1?(
          <ReplyForm id={-1} marginLeft={0} />
        ):null}
        <Portal>
          <CommentsRefresher />
        </Portal>
        {this.renderCommentNotFound()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    router:state.router
  }
}


export default inject("router","commentsStore")(observer(Comments));